/* GENERATED FILE — do not edit.
 * Produced by tools/brand-assets/build.mjs from tools/brand-assets/manifest.json.
 * Re-run:  node tools/brand-assets/build.mjs
 *
 * Paths are root-absolute and resolve against each project's own `public/`
 * directory, which holds an identical copy of the media. A component that renders
 * a face does not need to know which project it is inside.
 */

/** Display name → portrait. The signed-in user's name is literally "You". */
export const AVATARS: Record<string, string> = {
  "Sofia Amara": "/img/a/sofia.webp",
  "Elena Rusk": "/img/a/elena.webp",
  "Marcus T.": "/img/a/marcus.webp",
  "Dembe O.": "/img/a/dembe.webp",
  "Nadia K.": "/img/a/nadia.webp",
  "Tobi A.": "/img/a/tobi.webp",
  "Aisha Bello": "/img/a/aisha.webp",
  "Priscilla N.": "/img/a/priscilla.webp",
  "Jayden Cole": "/img/a/jayden.webp",
  "Kwame A.": "/img/a/kwame.webp",
  "Lena Ortiz": "/img/a/lena.webp",
  "Diego Santos": "/img/a/diego.webp",
  "Amara Obi": "/img/a/amara.webp",
  "Noah Kim": "/img/a/noah.webp",
  "Zara Ali": "/img/a/zara.webp",
  "Leo Mensah": "/img/a/leo.webp",
  "Jay Adeyemi": "/img/a/jay.webp",
  "Superfan X": "/img/a/superfanx.webp",
  "Mike W.": "/img/a/mikew.webp",
  "Bad User": "/img/a/baduser.webp",
  "You": "/img/a/you.webp"
};

/** Faces for people the seed data names but does not model — commenters, fans. */
export const FALLBACK_FACES: string[] = [
  "/img/a/f00.webp",
  "/img/a/f01.webp",
  "/img/a/f02.webp",
  "/img/a/f03.webp",
  "/img/a/f04.webp",
  "/img/a/f05.webp",
  "/img/a/f06.webp",
  "/img/a/f07.webp",
  "/img/a/f08.webp",
  "/img/a/f09.webp",
  "/img/a/f10.webp",
  "/img/a/f11.webp",
  "/img/a/f12.webp",
  "/img/a/f13.webp",
  "/img/a/f14.webp",
  "/img/a/f15.webp",
  "/img/a/f16.webp",
  "/img/a/f17.webp",
  "/img/a/f18.webp",
  "/img/a/f19.webp",
  "/img/a/f20.webp"
];

/** Category → its five post photographs, in manifest order. */
export const CATEGORY_MEDIA: Record<string, string[]> = {
  "life": [
    "/img/m/life-0.webp",
    "/img/m/life-1.webp",
    "/img/m/life-2.webp",
    "/img/m/life-3.webp",
    "/img/m/life-4.webp"
  ],
  "stream": [
    "/img/m/stream-0.webp",
    "/img/m/stream-1.webp",
    "/img/m/stream-2.webp",
    "/img/m/stream-3.webp",
    "/img/m/stream-4.webp"
  ],
  "pod": [
    "/img/m/pod-0.webp",
    "/img/m/pod-1.webp",
    "/img/m/pod-2.webp",
    "/img/m/pod-3.webp",
    "/img/m/pod-4.webp"
  ],
  "fit": [
    "/img/m/fit-0.webp",
    "/img/m/fit-1.webp",
    "/img/m/fit-2.webp",
    "/img/m/fit-3.webp",
    "/img/m/fit-4.webp"
  ],
  "edu": [
    "/img/m/edu-0.webp",
    "/img/m/edu-1.webp",
    "/img/m/edu-2.webp",
    "/img/m/edu-3.webp",
    "/img/m/edu-4.webp"
  ],
  "vlog": [
    "/img/m/vlog-0.webp",
    "/img/m/vlog-1.webp",
    "/img/m/vlog-2.webp",
    "/img/m/vlog-3.webp",
    "/img/m/vlog-4.webp"
  ],
  "trav": [
    "/img/m/trav-0.webp",
    "/img/m/trav-1.webp",
    "/img/m/trav-2.webp",
    "/img/m/trav-3.webp",
    "/img/m/trav-4.webp"
  ],
  "model": [
    "/img/m/model-0.webp",
    "/img/m/model-1.webp",
    "/img/m/model-2.webp",
    "/img/m/model-3.webp",
    "/img/m/model-4.webp"
  ],
  "music": [
    "/img/m/music-0.webp",
    "/img/m/music-1.webp",
    "/img/m/music-2.webp",
    "/img/m/music-3.webp",
    "/img/m/music-4.webp"
  ],
  "com": [
    "/img/m/com-0.webp",
    "/img/m/com-1.webp",
    "/img/m/com-2.webp",
    "/img/m/com-3.webp",
    "/img/m/com-4.webp"
  ],
  "art": [
    "/img/m/art-0.webp",
    "/img/m/art-1.webp",
    "/img/m/art-2.webp",
    "/img/m/art-3.webp",
    "/img/m/art-4.webp"
  ],
  "game": [
    "/img/m/game-0.webp",
    "/img/m/game-1.webp",
    "/img/m/game-2.webp",
    "/img/m/game-3.webp",
    "/img/m/game-4.webp"
  ],
  "glow": [
    "/img/m/glow-0.webp",
    "/img/m/glow-1.webp",
    "/img/m/glow-2.webp",
    "/img/m/glow-3.webp",
    "/img/m/glow-4.webp"
  ],
  "tech": [
    "/img/m/tech-0.webp",
    "/img/m/tech-1.webp",
    "/img/m/tech-2.webp",
    "/img/m/tech-3.webp",
    "/img/m/tech-4.webp"
  ],
  "dance": [
    "/img/m/dance-0.webp",
    "/img/m/dance-1.webp",
    "/img/m/dance-2.webp",
    "/img/m/dance-3.webp",
    "/img/m/dance-4.webp"
  ],
  "food": [
    "/img/m/food-0.webp",
    "/img/m/food-1.webp",
    "/img/m/food-2.webp",
    "/img/m/food-3.webp",
    "/img/m/food-4.webp"
  ]
};

/** Creator handle → the category their posts are drawn from. */
export const CREATOR_POOLS: Record<string, string> = {
  "sofiaa": "life",
  "elenalive": "stream",
  "marcusbeats": "pod",
  "dembefit": "fit",
  "nadiak": "edu",
  "tobivlogs": "vlog",
  "aishab": "trav",
  "priscilla": "model",
  "jaydenc": "music",
  "kwamea": "com",
  "lenaart": "art",
  "diegoplays": "game",
  "amaraobi": "glow",
  "noahk": "tech",
  "zaraali": "dance",
  "leochef": "food"
};

/** Creator handle → short slug, for file lookups. */
export const CREATOR_SLUGS: Record<string, string> = {
  "sofiaa": "sofia",
  "elenalive": "elena",
  "marcusbeats": "marcus",
  "dembefit": "dembe",
  "nadiak": "nadia",
  "tobivlogs": "tobi",
  "aishab": "aisha",
  "priscilla": "priscilla",
  "jaydenc": "jayden",
  "kwamea": "kwame",
  "lenaart": "lena",
  "diegoplays": "diego",
  "amaraobi": "amara",
  "noahk": "noah",
  "zaraali": "zara",
  "leochef": "leo"
};

/** Creator handle → display name, so a handle alone can find an avatar. */
export const CREATOR_NAMES: Record<string, string> = {
  "sofiaa": "Sofia Amara",
  "elenalive": "Elena Rusk",
  "marcusbeats": "Marcus T.",
  "dembefit": "Dembe O.",
  "nadiak": "Nadia K.",
  "tobivlogs": "Tobi A.",
  "aishab": "Aisha Bello",
  "priscilla": "Priscilla N.",
  "jaydenc": "Jayden Cole",
  "kwamea": "Kwame A.",
  "lenaart": "Lena Ortiz",
  "diegoplays": "Diego Santos",
  "amaraobi": "Amara Obi",
  "noahk": "Noah Kim",
  "zaraali": "Zara Ali",
  "leochef": "Leo Mensah"
};

/** Creator handle → 9:16 reel still, and its motion loop. */
export const REEL_STILLS: Record<string, string> = {
  "sofiaa": "/img/r/sofia.webp",
  "elenalive": "/img/r/elena.webp",
  "marcusbeats": "/img/r/marcus.webp",
  "dembefit": "/img/r/dembe.webp",
  "nadiak": "/img/r/nadia.webp",
  "tobivlogs": "/img/r/tobi.webp",
  "aishab": "/img/r/aisha.webp",
  "priscilla": "/img/r/priscilla.webp",
  "jaydenc": "/img/r/jayden.webp",
  "kwamea": "/img/r/kwame.webp",
  "lenaart": "/img/r/lena.webp",
  "diegoplays": "/img/r/diego.webp",
  "amaraobi": "/img/r/amara.webp",
  "noahk": "/img/r/noah.webp",
  "zaraali": "/img/r/zara.webp",
  "leochef": "/img/r/leo.webp"
};
export const REEL_LOOPS: Record<string, string> = {
  "sofiaa": "/img/r/sofia.mp4",
  "elenalive": "/img/r/elena.mp4",
  "marcusbeats": "/img/r/marcus.mp4",
  "dembefit": "/img/r/dembe.mp4",
  "nadiak": "/img/r/nadia.mp4",
  "tobivlogs": "/img/r/tobi.mp4",
  "aishab": "/img/r/aisha.mp4",
  "priscilla": "/img/r/priscilla.mp4",
  "jaydenc": "/img/r/jayden.mp4",
  "kwamea": "/img/r/kwame.mp4",
  "lenaart": "/img/r/lena.mp4",
  "diegoplays": "/img/r/diego.mp4",
  "amaraobi": "/img/r/amara.mp4",
  "noahk": "/img/r/noah.mp4",
  "zaraali": "/img/r/zara.mp4",
  "leochef": "/img/r/leo.mp4"
};

/** Creator handle → 3:1 profile cover. */
export const COVERS: Record<string, string> = {
  "sofiaa": "/img/c/sofia.webp",
  "elenalive": "/img/c/elena.webp",
  "marcusbeats": "/img/c/marcus.webp",
  "dembefit": "/img/c/dembe.webp",
  "nadiak": "/img/c/nadia.webp",
  "tobivlogs": "/img/c/tobi.webp",
  "aishab": "/img/c/aisha.webp",
  "priscilla": "/img/c/priscilla.webp",
  "jaydenc": "/img/c/jayden.webp",
  "kwamea": "/img/c/kwame.webp",
  "lenaart": "/img/c/lena.webp",
  "diegoplays": "/img/c/diego.webp",
  "amaraobi": "/img/c/amara.webp",
  "noahk": "/img/c/noah.webp",
  "zaraali": "/img/c/zara.webp",
  "leochef": "/img/c/leo.webp"
};

/** Post still → the loop that plays in its place. Only the nine video posts. */
export const MEDIA_VIDEOS: Record<string, string> = {
  "/img/m/life-0.webp": "/img/v/life-0.mp4",
  "/img/m/life-4.webp": "/img/v/life-4.mp4",
  "/img/m/edu-0.webp": "/img/v/edu-0.mp4",
  "/img/m/food-0.webp": "/img/v/food-0.mp4",
  "/img/m/game-0.webp": "/img/v/game-0.mp4",
  "/img/m/game-3.webp": "/img/v/game-3.mp4",
  "/img/m/glow-0.webp": "/img/v/glow-0.mp4",
  "/img/m/glow-2.webp": "/img/v/glow-2.mp4",
  "/img/m/model-0.webp": "/img/v/model-0.mp4"
};

/**
 * Creator handle → a post photograph that is the same picture as their reel.
 * Empty means no creator's reel is also in their own post pool, which is the
 * state the current manifest is curated into. The resolver deals around
 * anything listed here so one photograph never appears twice under one name.
 */
export const REEL_IN_POOL: Record<string, string> = {};

/** Moderation exhibits, admin only. */
export const EVIDENCE: Record<string, string> = {
  "replay-priscilla": "/img/e/replay-priscilla.webp",
  "ppv-diego": "/img/e/ppv-diego.webp"
};
